<template>
  <div class="wrap">
    <div class="content">
      <section class="main_title">赏 花 推 荐</section>
      <section class="date">
        <span>{{ time.year + '年' + '第' + time.week + '周' }}</span>
      </section>
      <section class="main">
        <ul>
          <li v-for="item in flowerList" :key="item.id">
            <div class="text">
              <div class="text_1">
                <img src="@/assets/image/anionScreen/flower.png" alt="" />
                <span>{{ item.name }} <i class="el-icon-arrow-right"></i></span>
              </div>
              <p class="text_2">最佳赏花点</p>
              <p class="text_3">{{ item.address }}</p>
            </div>
            <img :src="item.flowerImg" alt="" class="flower" />
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  components: {},
  data() {
    return {
      apiUrl: 'https://cl.gd-ib.cn/flowers/json/flowerList.json', //api地址
      timeUrl: 'https://cl.gd-ib.cn/flowers/json/yearMonth.json', //api地址
      flowerList: [],
      time: {},
      loading: ''
    }
  },
  mounted() {
    document.title = '赏花推荐'
    this.getTime()
    this.getData()
  },
  methods: {
    //获取数据
    getData() {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios
        .get(this.apiUrl)
        .then(({ data }) => {
          this.flowerList = data.list.slice(0, 10) || []
          for (let i of this.flowerList) {
            i.address = i.address.join('、')
          }
          this.loading.close()
        })
        .catch((e) => {
          this.loading.close()
        })
    },
    //获取时间
    getTime() {
      axios.get(this.timeUrl).then(({ data }) => {
        this.time = data || {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:math';
// $designWidth: 2304;
// $designHeight: 2390;
$designWidth: 2257;
$designHeight: 2390;
@function getVw($px) {
  @return math.div($px, $designWidth) * 100vw;
}
@function getVh($px) {
  @return math.div($px, $designHeight) * 100vh;
}
.wrap {
  // width: getVw(2304);
  // height: getVh(2390);
  width: getVw(2257);
  height: getVh(2390);
  background-color: #000;
  box-sizing: border-box;
  overflow: hidden;
  // padding: getVh(40) getVw(70);
  padding: getVh(40) getVw(170);
}
.content {
  width: getVw(1700);
  // height: getVh(2310);
  height: getVh(2310);
  margin: 0 auto;
  background-image: url(~@/assets/image/anionScreen/bg_flower.png);
  background-size: 100% getVh(260);
  // background-size: 100% getVh(280);
  background-repeat: no-repeat;
  background-color: #e5f3e8;
  padding: getVh(10) getVw(30) 0 getVw(30);
  box-sizing: border-box;
  overflow: hidden;
  .date {
    display: flex;
    justify-content: center;
    margin: 0 auto getVh(70) auto; // getVh(90)
    span {
      padding: 0 getVw(40);
      height: getVh(70);
      border-radius: getVw(40);
      background: linear-gradient(
        265.21deg,
        rgba(150, 242, 143, 1) 0%,
        rgba(215, 255, 162, 1) 100%
      );
      font-size: getVh(48);
      color: rgba(56, 56, 56, 1);
      line-height: getVh(70);
    }
  }
  .main {
    width: 100%;
    margin: 0 auto;
    border-radius: getVw(22);
    background: #fff;
    padding: getVh(32) getVw(32);
    box-sizing: border-box;
    ul {
      display: flex;
      flex-wrap: wrap;
      list-style: none;
      padding: 0;
      li {
        position: relative;
        width: 48%;
        height: getVh(358);
        overflow: hidden;
        margin-bottom: getVh(26);
        // box-shadow: 0 0 2px rgba(0, 0, 0, 0.6);
        border-radius: getVw(8);
        &:nth-child(2n-1) {
          margin-right: 4%;
        }
        div.text {
          position: absolute;
          left: getVw(20);
          top: getVh(20);
          .text_1 {
            position: relative;
            img {
              height: getVh(50);
            }
            span:nth-child(2) {
              position: absolute;
              top: -getVh(8);
              left: getVh(68);
              font-size: getVh(42);
              font-weight: 700;
              font-style: italic;
              i {
                font-weight: 700;
              }
            }
          }
          .text_2 {
            font-size: getVh(34);
            font-weight: 700;
            margin: getVh(16) 0;
          }
          .text_3 {
            width: 76%;
            font-size: getVh(28);
            line-height: getVh(40);
          }
        }
        img.flower {
          width: 100%;
          box-shadow: 0 0 1px rgba(0, 0, 0, 0.18);
          height: 100%;
        }
      }
    }
  }
}
.main_title {
  text-align: center;
  color: rgba(255, 200, 0, 1);
  font-size: getVh(94);
  font-weight: 900;
  -webkit-text-stroke: 2px #fff;
  text-stroke: 2px #fff;
  margin-bottom: getVh(20);
  text-shadow: getVw(6) getVw(6) #736a1a;
}
</style>
